import {useContext} from "react";
import CompanyContext from "../context/companyContext";

const useCompany = () => {
  return useContext(CompanyContext);
};
export default useCompany;
